import React from 'react';
import { CalendarDay, numberToDisplayString } from 'further-ui/utils';
import { Control, Controller } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import NumberInput from 'further-ui/components/NumberInput';
import Table, { Column as TableColumn } from 'further-ui/components/Table';

type RowType = {
  investmentId: string;
  date: CalendarDay;
  currentNumberOfUnits: number;
  allocatedUnits?: number;
};

type UnitToInvestmentAllocationTableProps = {
  unitsAllocationPerInvestment: Array<RowType>;
  onManualAllocationChange: () => void;
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  clearConsiderationForm: () => void;
};

const UnitToInvestmentAllocationTable: React.FC<
  UnitToInvestmentAllocationTableProps
> = ({
  unitsAllocationPerInvestment,
  control,
  index,
  onManualAllocationChange,
  clearConsiderationForm,
}) => {
  const renderAllocationInput = (rowIndex: number) => (
    <Controller
      control={control}
      name={`holdingClassRealisation.${index}.unitsAllocationPerInvestment.${rowIndex}.allocatedUnits`}
      render={({ field }) => (
        <NumberInput
          value={field.value ?? null}
          onChange={(value) => {
            field.onChange(value);
            clearConsiderationForm();
            onManualAllocationChange();
          }}
          name={field.name}
          decimals={2}
          fullWidth
          hideZeroValue
        />
      )}
    />
  );

  const rows = unitsAllocationPerInvestment.map((investment, index) => ({
    ...investment,
    id: investment.investmentId || `investment-${index}`,
  }));

  const columns: Array<TableColumn<(typeof rows)[number]>> = [
    {
      key: 'date',
      label: 'Investment date',
      render: (row) => row.date.toReadable(),
    },
    {
      key: 'currentNumberOfUnits',
      label: 'Units held',
      render: (row) => numberToDisplayString(row.currentNumberOfUnits),
    },
    {
      key: 'allocatedUnits',
      label: 'Units realised',
      render: (_, rowIndex) => renderAllocationInput(rowIndex),
    },
  ];

  return <Table columns={columns} rows={rows} />;
};

export default UnitToInvestmentAllocationTable;
